import { Menu as MenuIcon } from '@mui/icons-material';

const Menu = (): JSX.Element => <MenuIcon fontSize="inherit" />;

export default Menu;
